/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as UtilityTypes from '../utilities/types'

import * as ApiKeyTypes from './types'

export type CompanyApiKeysGetAllKey = ['keys', unknown]

export type CompanyApiKeysGetAllResponse = UtilityTypes.NewPaginator & {
  data?: Array<ApiKeyTypes.ResponseAPIKeyNoSecret>
}

export type CompanyApiKeysGetAllVariables = {
  body?: void
  query?: {
    /**
     * @default
     *     active
     */
    status?: 'active' | 'inactive'
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
    offset?: number
  }
}

export const companyApiKeysGetAll = makeData<
  CompanyApiKeysGetAllResponse,
  CompanyApiKeysGetAllKey,
  CompanyApiKeysGetAllVariables
>({
  method: 'get',
  name: 'companyApiKeysGetAll',
  summary: 'Get all API keys',
  path: '/keys',
  queryKey: ({ query }) => ['keys', query],
})

export type CompanyApiKeyCreateKey = ['keys', unknown]

export type CompanyApiKeyCreateResponse = ApiKeyTypes.ResponseAPIKeyNoSecret

export type CompanyApiKeyCreateVariables = {
  body?: ApiKeyTypes.RequestBodyAPIKeyNoSecret
  query?: void
}

export const companyApiKeyCreate = makeData<
  CompanyApiKeyCreateResponse,
  CompanyApiKeyCreateKey,
  CompanyApiKeyCreateVariables
>({
  method: 'post',
  name: 'companyApiKeyCreate',
  summary: 'Create an API key',
  path: '/keys',
  queryKey: ({ query }) => ['keys', query],
})

export type CompanyApiKeyGetKey = ['keys', string | undefined, unknown]

export type CompanyApiKeyGetResponse = ApiKeyTypes.ResponseAPIKeyNoSecret

export type CompanyApiKeyGetVariables = {
  keyId: string | undefined
  body?: void
  query?: void
}

export const companyApiKeyGet = makeData<
  CompanyApiKeyGetResponse,
  CompanyApiKeyGetKey,
  CompanyApiKeyGetVariables
>({
  method: 'get',
  name: 'companyApiKeyGet',
  summary: 'Get an API key',
  path: '/keys/{keyId}',
  queryKey: ({ query, keyId }) => ['keys', keyId, query],
})

export type CompanyApiKeyUpdateKey = ['keys', string | undefined, unknown]

export type CompanyApiKeyUpdateResponse =
  ApiKeyTypes.ResponseAPIKeyNoSecretAPIVersioning

export type CompanyApiKeyUpdateVariables = {
  keyId: string | undefined
  body?: ApiKeyTypes.RequestBodyAPIKeyUpdateAPIVersioning
  query?: void
}

export const companyApiKeyUpdate = makeData<
  CompanyApiKeyUpdateResponse,
  CompanyApiKeyUpdateKey,
  CompanyApiKeyUpdateVariables
>({
  method: 'put',
  name: 'companyApiKeyUpdate',
  summary: 'Update an API key',
  path: '/keys/{keyId}',
  queryKey: ({ query, keyId }) => ['keys', keyId, query],
})

export type CompanyApiKeyDeleteKey = ['keys', string | undefined, unknown]

export type CompanyApiKeyDeleteResponse = void

export type CompanyApiKeyDeleteVariables = {
  keyId: string | undefined
  body?: void
  query?: void
}

export const companyApiKeyDelete = makeData<
  CompanyApiKeyDeleteResponse,
  CompanyApiKeyDeleteKey,
  CompanyApiKeyDeleteVariables
>({
  method: 'delete',
  name: 'companyApiKeyDelete',
  summary: 'Delete an API key',
  path: '/keys/{keyId}',
  queryKey: ({ query, keyId }) => ['keys', keyId, query],
})

export type InternalCompanyApiKeysGetAllKey = [
  'companies',
  string | undefined,
  'keys',
  unknown,
]

export type InternalCompanyApiKeysGetAllResponse = UtilityTypes.NewPaginator & {
  data?: Array<ApiKeyTypes.ResponseAPIKeyNoSecretAPIVersioning>
}

export type InternalCompanyApiKeysGetAllVariables = {
  companyId: string | undefined
  body?: void
  query?: {
    /**
     * @default
     *     active
     */
    status?: 'active' | 'inactive'
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
    offset?: number
  }
}

export const internalCompanyApiKeysGetAll = makeData<
  InternalCompanyApiKeysGetAllResponse,
  InternalCompanyApiKeysGetAllKey,
  InternalCompanyApiKeysGetAllVariables
>({
  method: 'get',
  name: 'internalCompanyApiKeysGetAll',
  summary: 'Get all API keys associated with a company',
  path: '/companies/{companyId}/keys',
  queryKey: ({ query, companyId }) => ['companies', companyId, 'keys', query],
})

export type InternalCompanyApiKeyCreateKey = [
  'companies',
  string | undefined,
  'keys',
  unknown,
]

export type InternalCompanyApiKeyCreateResponse =
  ApiKeyTypes.ResponseAPIKeyNoSecretAPIVersioning

export type InternalCompanyApiKeyCreateVariables = {
  companyId: string | undefined
  body?: ApiKeyTypes.RequestBodyAPIKeyNoSecretAPIVersioning
  query?: void
}

export const internalCompanyApiKeyCreate = makeData<
  InternalCompanyApiKeyCreateResponse,
  InternalCompanyApiKeyCreateKey,
  InternalCompanyApiKeyCreateVariables
>({
  method: 'post',
  name: 'internalCompanyApiKeyCreate',
  summary: 'Create an API key associated with a company',
  path: '/companies/{companyId}/keys',
  queryKey: ({ query, companyId }) => ['companies', companyId, 'keys', query],
})

export type InternalCompanyApiKeyGetKey = [
  'companies',
  string | undefined,
  'keys',
  string | undefined,
  unknown,
]

export type InternalCompanyApiKeyGetResponse =
  ApiKeyTypes.ResponseAPIKeyNoSecretAPIVersioning

export type InternalCompanyApiKeyGetVariables = {
  companyId: string | undefined
  keyId: string | undefined
  body?: void
  query?: void
}

export const internalCompanyApiKeyGet = makeData<
  InternalCompanyApiKeyGetResponse,
  InternalCompanyApiKeyGetKey,
  InternalCompanyApiKeyGetVariables
>({
  method: 'get',
  name: 'internalCompanyApiKeyGet',
  summary: 'Get an API key associated with a company',
  path: '/companies/{companyId}/keys/{keyId}',
  queryKey: ({ query, companyId, keyId }) => [
    'companies',
    companyId,
    'keys',
    keyId,
    query,
  ],
})

export type InternalCompanyApiKeyUpdateKey = [
  'companies',
  string | undefined,
  'keys',
  string | undefined,
  unknown,
]

export type InternalCompanyApiKeyUpdateResponse =
  ApiKeyTypes.ResponseAPIKeyNoSecretAPIVersioning

export type InternalCompanyApiKeyUpdateVariables = {
  companyId: string | undefined
  keyId: string | undefined
  body?: ApiKeyTypes.RequestBodyAPIKeyUpdateAPIVersioning
  query?: void
}

export const internalCompanyApiKeyUpdate = makeData<
  InternalCompanyApiKeyUpdateResponse,
  InternalCompanyApiKeyUpdateKey,
  InternalCompanyApiKeyUpdateVariables
>({
  method: 'put',
  name: 'internalCompanyApiKeyUpdate',
  summary: 'Update an API key associated with a company',
  path: '/companies/{companyId}/keys/{keyId}',
  queryKey: ({ query, companyId, keyId }) => [
    'companies',
    companyId,
    'keys',
    keyId,
    query,
  ],
})

export type InternalCompanyApiKeyDeleteKey = [
  'companies',
  string | undefined,
  'keys',
  string | undefined,
  unknown,
]

export type InternalCompanyApiKeyDeleteResponse = void

export type InternalCompanyApiKeyDeleteVariables = {
  companyId: string | undefined
  keyId: string | undefined
  body?: void
  query?: void
}

export const internalCompanyApiKeyDelete = makeData<
  InternalCompanyApiKeyDeleteResponse,
  InternalCompanyApiKeyDeleteKey,
  InternalCompanyApiKeyDeleteVariables
>({
  method: 'delete',
  name: 'internalCompanyApiKeyDelete',
  summary: 'Delete an API key associated with a company',
  path: '/companies/{companyId}/keys/{keyId}',
  queryKey: ({ query, companyId, keyId }) => [
    'companies',
    companyId,
    'keys',
    keyId,
    query,
  ],
})
